import { render, staticRenderFns } from "./managers-list.vue?vue&type=template&id=91bf9a78&"
import script from "./managers-list.vue?vue&type=script&lang=js&"
export * from "./managers-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports